import React, { useState, useEffect } from 'react'
import {
    Button,
    Checkbox,
    FormControlLabel,
    InputBase,
    Grid
} from "@material-ui/core";
import useStyles from "./styles";
import { SearchOutlined as SearchIcon } from '@material-ui/icons';
import SearchGridSSP from '../../components/table/SearchGrid_SSP'
import Breadcrums from '../../components/BreadCrums/breadcrums';
import TopSpacer from '../../components/Common/spacer/TopSpacer';

import Submitted from "../../assets/img/action/Submitted.svg";
import ReviewsButtonClicked from "../../assets/img/action/ReviewsButtonClicked.svg";
import EmailOpen from "../../assets/img/action/EmailOpen.svg";

import { PostDataAPI } from '../../Services/APIService';

import Loader from '../../components/Loader/Loader';
import { ActionDialog } from "../../components/ActionDialog/ActionDialog";
import { withSnackbar } from "../../components/Message/Alert";
import ReviewRequest from './components/reviewRequest/ReviewRequest';
import ClearIcon from '@material-ui/icons/Clear';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { Table, TableRow, Collapse, Empty, Dropdown, message, Menu, Typography, Tag } from 'antd';
import { InputBaseField, SelectField, TextareaField } from '../../components/InputField/InputField';
import { formatNumberWithCommas } from '../../../src/components/Common/Extensions';
import moment from 'moment';
import Tooltip from '@material-ui/core/Tooltip';

function Reviews({ ...props }) {
    const classes = useStyles();
    const { showMessage } = props;


    //action dialog
    const [actiondialogState, setActionDialogState] = useState({
        showHide: false, type: "confirm", message: "",
    })

    const [reviewRequest, setReviewRequest] = useState(false);

    const openReviewRequest = () => {
        setReviewRequest(true)
    }

    const closeReviewRequest = () => {
        setReviewRequest(false)
    }

    const reviewSuccessClose = (message) => {
        showMessage("Success", message, "success", 3000);
        setReviewRequest(false);
        loadStats(state?.filterType, state?.filterDates);

    }


    const handleClearInput = (name) => {
        setValue('')
        loadStats(state?.filterType, state?.filterDates, true);
    };

    const showActionDialog = (message, type, OnOkCallback, OnCancellCallback) => {
        setActionDialogState(prevState => ({
            ...prevState,
            type: type,
            showHide: true,
            message: message,
            onClickOk: OnOkCallback,
            OnClickCancel: OnCancellCallback
        }));
    }


    const handleChange = e => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }));
        if (value == 'this_week') {
            setState(prevState => ({
                ...prevState,
                filterDates: []
            }));
            loadStats(value);
        }
    }
    const handleDateChange = dates => {
        debugger
        //const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            filterDates: dates
        }));
        if (dates)
            loadStats(state?.filterType, dates);
    }

    const [state, setState] = useState({
        confirmed: '', shipped: '', inTransit: '', delivered: '', returned: '',
        claimed: '', voided: '', deleted: '', filterType: 'this_week'
    });
    const [isLoading, setIsLoading] = useState(false);

    const [reviewsStatusBoxes, setReviewsStatusBoxes] = useState([
        {
            value: 'Request Submitted',
            reviewStatus: 'submitted',
            numbers: 0,
            Icon: Submitted,

        },
        {
            value: 'Email Opened',
            reviewStatus: 'opened',
            numbers: 0,
            Icon: EmailOpen,


        },
        {
            value: 'Review Button Clicked',
            reviewStatus: 'reviewed',
            numbers: 0,
            Icon: ReviewsButtonClicked,
        },

    ]);

    const [ReviewsData, setReviewsData] = useState([]);

    const [searchFilter, setValue] = useState('');
    const handleInputChange = (event) => {
        setValue(event.target.value);
    };
    const handleSearchKeyPress = (e) => {
        const currValue = e.target.value;

        if (e.charCode == 13 && currValue && currValue.trim().length > 0) {
            //setValue(currValue);
            loadReviews(state?.filterType, state?.filterDates)
        }
    }
    const [isDataGridUpdate, setIsDataGridUpdate] = useState(false);
    const handleDataGridUpdate = () => {
        setIsDataGridUpdate(!isDataGridUpdate);
    }


    const [filteredStatus, setFilteredStatus] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [sortColumn, setSortColumn] = useState('');
    const [sortOrder, setSortOrder] = useState('');
    const handleStatusClick = (event, reviewStatus) => {
        var lstStatus = filteredStatus;
        if (event.target.checked) {
            lstStatus.push(reviewStatus);
        }
        else {
            lstStatus = lstStatus.filter(s => s != reviewStatus)
        }
        setFilteredStatus(lstStatus);
        if (state?.filterType == 'custom' && (!state?.filterDates || state?.filterDates.length == 0))
            return;
        loadReviews(state?.filterType, state?.filterDates, currentPage, pageSize, sortColumn, sortOrder, false, lstStatus);

        //handleDataGridUpdate();
    }
    //const [filterType, setFilterType] = useState('this_week');

    const handleGridChange = (page, pageSize, isClearSearch, sortColumn, sortOrder) => {
        setCurrentPage(page);
        setPageSize(pageSize);
        setSortColumn(sortColumn);
        setSortOrder(sortOrder);
        loadReviews(state?.filterType, state?.filterDates, page, pageSize, sortColumn, sortOrder, isClearSearch, filteredStatus);
    }
    const [totalRows, setTotalRows] = useState(0);
    const loadReviews = (filterType, filterDates, page, pageSize, sortColumn, sortOrder, isClearSearch, lstStatus) => {
        lstStatus = lstStatus ? lstStatus : [];
        debugger;
        setIsLoading(true);
        var params = {
            extraParams: [filterType],
            pageSize: pageSize, pageNumber: page, sortColumn: sortColumn ? sortColumn : '', sortOrder: sortOrder ? sortOrder : ''
        };
        if (filterType == 'custom') {
            debugger;
            var startDate = moment().clone().isoWeekday(1).startOf('day');
            var endDate = moment();
            if (!filterDates || filterDates.length < 2) {
                setState(prevState => ({
                    ...prevState,
                    filterDates: [startDate, endDate]
                }));
                showMessage("Warning", "Custom dates are missing, data will be loaded for current week", "warning");
            }
            else {
                startDate = new Date(filterDates[0]);
                endDate = new Date(filterDates[1]);
            }
            params.extraParams.push(startDate);
            params.extraParams.push(endDate);
        }
        params.extraParams.push(isClearSearch ? '' : searchFilter);
        params.extraParams.push(lstStatus.map(status => `'${status}'`).join(','));
        PostDataAPI("fdnreviewrequest/loadGrid", params).then((result) => {
            if (result.success && result.data) {
                var record = result.data.map(item => {
                    item.reviewTo = !item.reviewTo ? '' : item.reviewTo == 'figgers_communication' ? 'HCT~FCI' : 'HCT~FF'
                    return { ...item }
                });
                setTotalRows(result.dataCount);
                setReviewsData(record);
                //setFilteredReviewsData(record);
                handleDataGridUpdate();
            }
            else {
                showMessage("Error", result.message, "error", 3000);
            }
            setIsLoading(false);
        });
    }
    const [totalCount, setTotalCount] = useState();

    const loadStats = (filterType, filterDates, isClearSearch) => {

        setIsLoading(true);
        var params = [filterType];//[filter ? filter : filters.salesFilter];
        if (filterType == 'custom') {
            params.push(new Date(filterDates[0]));
            params.push(new Date(filterDates[1]));
        }
        PostDataAPI("fdnreviewrequest/loadStats", params).then((result) => {
            setIsLoading(false);
            if (result.success && result.data) {
                //setTotalCount(result.data.total);
                debugger;
                setReviewsStatusBoxes(prevState =>
                    prevState.map(obj => ({
                        ...obj,
                        numbers: result.data[obj.reviewStatus] || 0
                    })));
                //setSubmittedCount(result.data.submitted);
                //setOpenedCount(result.data.opened);
                //setReviewedCount(result.data.reviewed);
                loadReviews(filterType, filterDates, currentPage, pageSize, sortColumn, sortOrder, isClearSearch, filteredStatus);
            }
            else {
                showMessage("Error", result.message, "error", 3000);
            }

        });
    }
    const topActions = [
        { key: 'this_week', label: 'This Week' },
        /*{ key: 'this_month', label: 'This Month' },*/
        { key: 'custom', label: 'Custom' }
    ];
    const triggerMenu = (type) => {
        //if (filteredApplicationsData && filteredApplicationsData.length > 0) {
        //    const applicationIds = filteredApplicationsData.map(item => item.applicationId);
        //    const postData = {
        //        applicationIds: applicationIds,
        //        type: type, // Replace 'yourAdditionalData' with the actual data you want to send
        //        applicationType: applicationType
        //    };
        //    setIsLoading(true);
        //    PostDataAPI("fdnmcchromicconnect/exportApplications", postData).then((result) => {
        //        setIsLoading(false);
        //        if (result.success && result.data != null) {
        //            if (type == 'print' || type == 'pdf') {
        //                handlePrint(result.data);
        //            } else {
        //                window.open("." + result.data, "_blank")
        //            }

        //        } else {

        //        }
        //    })
        //} else {
        //    showMessage("Error", "No record exists", "error", 3000);
        //}


    }
    useEffect(() => {
        loadStats();
    }, []);

    return (
        <>
            {isLoading ? <Loader></Loader> : ''}
            <TopSpacer></TopSpacer>

            <div className={classes.header}>

                <Grid container alignItems="baseline">
                    <Grid item lg={12}>
                        <Breadcrums parentLink={"Reviews"} currentLink={""} isBack={true}></Breadcrums>
                    </Grid>
                </Grid>

            </div>

            <Grid container className={classes.container}>
                <h1 className={classes.heading}>
                    Reviews Sent Email Status
                </h1>
            </Grid>

            <Grid container row className={classes.container}>

                <div className={classes.statusBoxContainer}>

                    {reviewsStatusBoxes.map((item, i) => (
                        <>
                            <FormControlLabel
                                className={classes.checkBoxFormLabel}
                                control={
                                    <Checkbox
                                        name="checkedB"
                                        color="primary"
                                        className={classes.checkBoxBtn}
                                        onClick={(e) => { handleStatusClick(e, item.reviewStatus) }}
                                    />
                                }
                                label={<>
                                    <div className={item.reviewStatus == "submitted" ? classes.statusBoxes + " " + "Submitted" :
                                        item.reviewStatus == "opened" ? classes.statusBoxes + " " + "EmailOpened" :
                                            item.reviewStatus == "reviewed" ? classes.statusBoxes + " " + "ReviewButton" : ''
                                    }>

                                        <div className={classes.statusBoxContent}>
                                            <span style={{
                                                fontSize: '35px',
                                                color: 'white'
                                            }} >
                                                {formatNumberWithCommas(item.numbers)} </span>
                                            <h3>{item.value}

                                            </h3>
                                        </div>
                                        <img src={item.Icon} />

                                    </div>
                                </>}
                            />
                        </>
                    ))}

                </div>

            </Grid>

            <Grid row className={classes.gridHeader}>



                {/*<div className={classes.gridActions}>*/}

                {/*    <div className="textCenter">*/}

                {/*<Dropdown overlay={<Menu>*/}
                {/*    {*/}
                {/*        topActions.map((menuItem, index) => {*/}
                {/*            return <Menu.Item*/}

                {/*                key={menuItem.key}*/}
                {/*                onClick={() => triggerMenu(menuItem.key)}*/}
                {/*            > <img src={menuItem.icon} /> {menuItem.label}*/}
                {/*            </Menu.Item>*/}
                {/*        })*/}
                {/*    }*/}
                {/*</Menu>} trigger={["click"]} */}
                {/*    className={classes.actionDropDown}>*/}
                {/*    <Button className={classes.actionBtn}>*/}
                {/*        Export <ArrowDropDownIcon />*/}
                {/*    </Button>*/}
                {/*</Dropdown>*/}
                {/*    </div>*/}


                {/*</div>*/}
                {state?.filterType == 'custom' ?
                    <Grid item xs={12} sm={12} md={2} lg={2} xl={2} style={{ marginRight: '5px' }} >
                        <InputBaseField
                            id="filterDates"
                            name="filterDates"
                            type="dateRange"
                            value={state.filterDates}
                            handleChangeDate={handleDateChange}
                            placeholder='Date'
                        />
                        {/*{errorMessages.errorCompanyName && !state.companyName ? (<FormHelperText style={{ color: "red" }} >*/}
                        {/*    Please enter company name*/}
                        {/*</FormHelperText>) : ('')}*/}
                    </Grid>
                    : ''}
                <Grid item xs={12} sm={12} md={1} lg={1} xl={1} >
                    <select
                        size="small"
                        native
                        name="filterType"
                        value={state?.filterType}
                        onChange={handleChange}
                        placeholder="Select"
                        label="Select"

                        className={classes.selectBaseInput}>
                        {topActions.map((option, index) =>
                            <option value={option.key}>{option.label}</option>
                        )}
                    </select>
                </Grid>
                <div className={classes.gridActions}>
                    <Button className={classes.changeBtn} onClick={openReviewRequest}>Ask for reviews</Button>
                </div>
                <div className={classes.gridActions} style={{ marginRight: '7px' }} >
                    <Tooltip title="Search & Press 'Enter'" placement="top">
                        <InputBase
                            value={searchFilter}
                            placeholder="Type & Enter"
                            className="grid-search-input"
                            startAdornment={<SearchIcon />}
                            onChange={handleInputChange}
                            onKeyPress={handleSearchKeyPress}
                            endAdornment={searchFilter ? <ClearIcon style={{ cursor: 'pointer' }} onClick={() => { handleClearInput('search') }} /> : ''}
                        />
                    </Tooltip>

                </div>
            </Grid>

            <Grid row className={classes.container} >
                <SearchGridSSP columns="ReviewsData"
                    list={ReviewsData}
                    noRecordMsg="No review exists"
                    Icon={true}
                    filter={searchFilter}
                    isUpdate={isDataGridUpdate}
                    isTopPagination={true}
                    handlePageChange={handleGridChange}
                    totalRows={totalRows}
                />
            </Grid>


            <ActionDialog
                type={actiondialogState.type}
                message={actiondialogState.message}
                actiondialogOpenClose={actiondialogState.showHide}
                onSubmit={actiondialogState.onClickOk}
                onCancel={() =>
                    setActionDialogState(prevState => ({
                        ...prevState, showHide: false
                    }))
                }
                onClose={() => setActionDialogState(prevState => ({
                    ...prevState, showHide: false
                }))

                }
            />

            {reviewRequest ?
                <ReviewRequest dialogOpenClose={openReviewRequest} handleClose={closeReviewRequest} handleSuccessClose={reviewSuccessClose}></ReviewRequest>
                : ''}

        </>
    )

}

export default withSnackbar(Reviews);